<app-font-size
  [fontSize]="fontSize"
  [lineHeight]="lineHeight"
  (fontSizeChange)="editSize($event)">
</app-font-size>
<app-font-family
  [fontFamily]="fontFamily"
  [fontWeight]="fontWeight"
  (fontFamilyChange)="editStyle($event)">
</app-font-family>